//React
import * as React from 'react';

import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

function MobileComplaintWidget({sSystemName})
{
    let systemConfig = require('../config/' + sSystemName + '.json');
    let systemCSS = require('../config/' + sSystemName + '.css');

    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [country, setCountry] = React.useState('United States');
    const [city, setCity] = React.useState('');
    const [zip, setZip] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [disturbanceStart, setDisturbanceStart] = React.useState(dayjs());
    const [disturbanceEnd, setDisturbanceEnd] = React.useState(dayjs());
    const [disturbanceDetails, setDisturbanceDetails] = React.useState('');

    const eventFirstNameChanged = (event) => 
    {
        setFirstName(event.target.value);
    };

    const eventLastNameChanged = (event) => 
    {
        setLastName(event.target.value);
    };

    const eventCountryChanged = (event) => 
    {
        setCountry(event.target.value);
    };

    const eventCityChanged = (event) => 
    {
        setCity(event.target.value);
    };

    const eventZipChanged = (event) => 
    {
        setZip(event.target.value);
    };

    const eventAddressChanged = (event) => 
    {
        setAddress(event.target.value);
    };

    const eventDisturbanceDetailsChanged = (event) => 
    {
        setDisturbanceDetails(event.target.value);
    };

    const countries = [
        "United States",
        "Mexico",
        "Canada"
    ];

    const eventSubmitComplaint = () => 
    {
        const formData = 
        {
            firstName, 
            lastName,
            country,
            city,
            zip,
            address,
            disturbanceStart,
            disturbanceEnd,
            disturbanceDetails
        };

        alert("Submit->" + JSON.stringify({formData}));
    }

    return (
        <div id="widget_mobile_complaint">
            <h2>Complaint Form</h2>
            <table className='horizontal_fill'>
                <tbody>
                    <tr>
                        <td>
                            <h3>Personal Info</h3>
                        </td>
                    </tr>
                    <tr>
                        <hr></hr>
                    </tr>
                    <tr>
                        <td>
                            <TextField className='horizontal_fill' label="First Name" variant="filled" value={firstName} onChange={eventFirstNameChanged}></TextField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextField className='horizontal_fill' label="Last Name" variant="filled" value={lastName} onChange={eventLastNameChanged}></TextField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h3>Location</h3>
                        </td>
                    </tr>
                    <tr>
                        <hr></hr>
                    </tr>
                    <tr>
                        <td>
                            <FormControl>
                                <InputLabel id="select_country_label">Country</InputLabel>
                                <Select 
                                    id="select_country" 
                                    labelId="select_country_label"
                                    label="Country"
                                    value={country}
                                    onChange={eventCountryChanged} >
                                    {
                                        countries.map((c) => 
                                        (
                                            <MenuItem key={c} value={c}>{c}</MenuItem>
                                        )
                                        )
                                    }
                                </Select>
                            </FormControl>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextField className='horizontal_fill' label="City" variant="filled" value={city} onChange={eventCityChanged}></TextField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextField id="textfield_zip" label="ZIP Code" variant="filled" value={zip} onChange={eventZipChanged}></TextField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextField className='horizontal_fill' label="Address" variant="filled" value={address} onChange={eventAddressChanged}></TextField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h3>Disturbance</h3>
                        </td>
                    </tr>
                    <tr>
                        <hr></hr>
                    </tr>
                    <tr>
                        <td>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker className='horizontal_fill' label="Disturbance Start" value={disturbanceStart} onChange={(newValue) => setDisturbanceStart(newValue)} />
                            </LocalizationProvider>            
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker className='horizontal_fill' label="Disturbance End" value={disturbanceEnd} onChange={(newValue) => setDisturbanceEnd(newValue)} />
                            </LocalizationProvider>     
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextField className='horizontal_fill' label="Description of Disturbance" variant="filled" value={disturbanceDetails} onChange={eventDisturbanceDetailsChanged} multiline></TextField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Button className='horizontal_fill' variant="contained" onClick={eventSubmitComplaint}>Save</Button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default MobileComplaintWidget